import React, { ReactNode, Suspense, useState } from 'react';
import { styled } from '@mui/material/styles';
import { FileData, FileType } from 'API';
import FileModal from './modals/FileModal';

const StyledButton = styled('button')({
  background: 'none',
  border: 'none',
  color: 'inherit',
  display: 'inline-block',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  outline: 'none',
  padding: 0,
  textAlign: 'inherit',
  '&:hover': {
    cursor: 'pointer',
  },
});

interface Props {
  children: ReactNode;
  className?: string;
  file: FileData;
  fileTypeOptions?: Array<FileType>;
  style?: React.CSSProperties;
  withSidebar?: boolean;
}

const InlineFileModalButton: React.FC<Props> = (
  {
    className, file, fileTypeOptions, children, style, withSidebar,
  }: Props,
) => {
  const [open, setOpen] = useState(false);

  return file.original ? (
    <>
      <StyledButton
        className={className}
        style={style}
        onClick={() => setOpen(true)}
        type="button"
      >
        {children}
      </StyledButton>
      {open && (
        <Suspense fallback={null}>
          <FileModal
            file={file}
            fileTypeOptions={fileTypeOptions}
            open={open}
            setOpen={setOpen}
            withSidebar={withSidebar}
          />
        </Suspense>
      )}
    </>
  ) : null;
};

export default InlineFileModalButton;
